window.onerror = function (message, source, lineno, colno, error) {
  // Suppress all errors
  return true; // Prevents the default browser behavior (showing errors in the console)
};

// check which additional product (in this case brustband) is selected
// setInterval(() => {

const optionSelectorAdditionalProduct = document.querySelectorAll(
  ".fi-custom-option-selector-additional-product .wrapper-dropdown"
);

optionSelectorAdditionalProduct.forEach(
  (optionSelectorAdditionalProductSelected) => {
    optionSelectorAdditionalProductSelected.addEventListener("click", () => {
      var additional_selected_product_id = document.querySelector(
        ".fi-custom-option-selector-additional-product .destination"
      ).dataset.productId;

      // make selected product selector group active
      document
        .querySelectorAll(
          ".fi-custom-option-selector-additional-product-options"
        )
        .forEach(function (AdditionalProductOptions) {
          AdditionalProductOptions.classList.remove(
            "fi-custom-option-selector-additional-product-selected"
          );
          if (
            AdditionalProductOptions.dataset.productId ==
            additional_selected_product_id
          ) {
            AdditionalProductOptions.classList.add(
              "fi-custom-option-selector-additional-product-selected"
            );
          }
        });

      // make selected product data active
      document
        .querySelectorAll(".additional-product-data")
        .forEach(function (additionalProductDataItem) {
          additionalProductDataItem.classList.remove(
            "additional-product-data-selected"
          );
          if (
            additionalProductDataItem.dataset.additionalProductDataId ==
            additional_selected_product_id
          ) {
            additionalProductDataItem.classList.add(
              "additional-product-data-selected"
            );
          }
        });
    });
  }
);

// }, 500);

//

// selectedAdditionalAll.forEach((selectedAdditionalAllselected) => {
//     const selectedAdditionaloptionsContainer = selectedAdditionalAllselected.children[2];
//     const selectedAdditionaloptionsList = selectedAdditionalAllselected.querySelectorAll("div.wrapper-dropdown li");
// const selectedAdditionalAll = document.querySelector(".fi-custom-option-selector-additional-product-selected .wrapper-dropdown");

// selectedAdditionalAll.addEventListener("click", () => {
setInterval(() => {
  var additional_product_option1 = document.querySelector(
    ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
  ).dataset.optionValue;
  var additional_product_option2 = document.querySelector(
    ".fi-custom-option-selector-additional-product-selected .option-set-2 .destination"
  ).dataset.optionValue;
  var additional_product_selected_variant_id = null;

  document
    .querySelectorAll(
      ".additional-product-data-selected .additional-product-options-data"
    )
    .forEach(function (additionalProductOptionsDataItem) {
      additionalProductOptionsDataItem.classList.remove(
        "additional-product-variant-selected"
      );

      if (
        additionalProductOptionsDataItem.dataset.optionFirst ==
          additional_product_option1 &&
        additionalProductOptionsDataItem.dataset.optionSecond ==
          additional_product_option2
      ) {
        additional_product_selected_variant_id =
          additionalProductOptionsDataItem.dataset.variantId;
      }
    });

  document
    .querySelector(
      `.additional-product-options-data[data-variant-id="${additional_product_selected_variant_id}"]`
    )
    .classList.add("additional-product-variant-selected");
}, 500);
// });

// });

const selectedMainAll = document.querySelectorAll(
  ".fi-custom-option-selector-main-product .wrapper-dropdown"
);

selectedMainAll.forEach((selectedMainAllselected) => {
  const selectedMainoptionsContainer = selectedMainAllselected.children[2];
  const selectedMainoptionsList = selectedMainAllselected.querySelectorAll(
    "div.wrapper-dropdown li"
  );

  selectedMainAllselected.addEventListener("click", () => {
    var main_product_option1 = document.querySelector(
      ".fi-custom-option-selector-main-product .option-set-1 .destination"
    ).dataset.optionValue;
    var main_product_option2 = document.querySelector(
      ".fi-custom-option-selector-main-product .option-set-2 .destination"
    ).dataset.optionValue;
    var main_product_selected_variant_id = null;

    document
      .querySelectorAll(".main-product-options-data")
      .forEach(function (mainProductOptionsDataItem) {
        mainProductOptionsDataItem.classList.remove(
          "main-product-variant-selected"
        );
        if (
          mainProductOptionsDataItem.dataset.optionFirst ==
            main_product_option1 &&
          mainProductOptionsDataItem.dataset.optionSecond ==
            main_product_option2
        ) {
          main_product_selected_variant_id =
            mainProductOptionsDataItem.dataset.variantId;
        }
      });

    document
      .querySelector(
        `.main-product-options-data[data-variant-id="${main_product_selected_variant_id}"]`
      )
      .classList.add("main-product-variant-selected");
  });
});

const selectedAll = document.querySelectorAll(".wrapper-dropdown");

selectedAll.forEach((selected) => {
  const optionsContainer = selected.children[2];
  const optionsList = selected.querySelectorAll("div.wrapper-dropdown li");

  selected.addEventListener("click", () => {
    let arrow = selected.children[1];

    if (selected.classList.contains("active")) {
      handleDropdown(selected, arrow, false);
    } else {
      let currentActive = document.querySelector(".wrapper-dropdown.active");

      if (currentActive) {
        let anotherArrow = currentActive.children[1];
        handleDropdown(currentActive, anotherArrow, false);
      }

      handleDropdown(selected, arrow, true);
    }
  });

  // update the display of the dropdown
  for (let o of optionsList) {
    o.addEventListener("click", () => {
      selected.querySelector(".selected-display").innerHTML = o.innerHTML;
      selected.querySelector(".selected-display").dataset.optionValue =
        o.dataset.optionValue;
      selected.querySelector(".selected-display").dataset.productId =
        o.dataset.productId;

      document
        .querySelectorAll(".wrapper-dropdown .destination")
        .forEach((element) => {
          // Check if the data-option-value is not 'empty'
          setInterval(() => {
            if (element.dataset.optionValue != "empty") {
              // Check the locale
              const locale = document.querySelector("#locale-iso-code")
                ? document.querySelector("#locale-iso-code").value
                : "default";

              // Modify the data-text based on the locale
              element.dataset.textContent = element.dataset.textContent
                .replace("wählen", "")
                .trim();
            }
          }, 10);
        });
    });
  }
});

// check if anything else other than the dropdown is clicked
window.addEventListener("click", function (e) {
  if (e.target.closest(".wrapper-dropdown") === null) {
    closeAllDropdowns();
  }
});
setInterval(() => {
  // close all the dropdowns
  function closeAllDropdowns() {
    const selectedAll = document.querySelectorAll(".wrapper-dropdown");
    selectedAll.forEach((selected) => {
      const optionsContainer = selected.children[2];
      let arrow = selected.children[1];

      handleDropdown(selected, arrow, false);
    });
  }
}, 500);

// open all the dropdowns
function handleDropdown(dropdown, arrow, open) {
  if (open) {
    arrow.classList.add("rotated");
    dropdown.classList.add("active");
  } else {
    arrow.classList.remove("rotated");
    dropdown.classList.remove("active");
  }
}

//
// price change
setInterval(() => {
  if (
    document.querySelector(
      ".fi-custom-option-selector-additional-product .destination"
    ).dataset.productId == "empty" ||
    document.querySelector(
      ".fi-custom-option-selector-additional-product .destination"
    ).dataset.productId == "null"
  ) {
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .destination"
      ).dataset.optionValue != "empty"
    ) {
      document.querySelector(".fi-bundle-product-custom-price").style.display =
        "none";
      document.querySelector(".product-info__price").style.display = "block";
      var mainProductVariantDiv = document.querySelector(
        ".main-product-options-data.main-product-variant-selected"
      );
      document.querySelector(".product-info__price sale-price").innerHTML =
        mainProductVariantDiv.dataset.variantPriceWithSymbol;
      document.querySelector(
        ".product-info__price compare-at-price"
      ).innerHTML = mainProductVariantDiv.dataset.comparePriceWithSymbol;

      var mainProductDiscountPercentage =
        100 -
        (
          (parseFloat(mainProductVariantDiv.dataset.variantPrice) /
            parseFloat(mainProductVariantDiv.dataset.comparePrice)) *
          100
        ).toFixed(0);
      document.querySelector(
        ".product-info__price .product-info__badge-list .badge--on-sale"
      ).innerHTML =
        '<span class="saving-lang-text"></span>' +
        mainProductDiscountPercentage +
        "%";
    }
  } else {
    document.querySelector(".fi-bundle-product-custom-price").style.display =
      "none";
    document.querySelector(".product-info__price").style.display = "block";

    var takePriceAdditional = 0;
    var takePriceCompareAdditional = 0;
    //

    var mainProductVariantDiv = document.querySelector(
      ".main-product-options-data.main-product-variant-selected"
    );
    var additionalProductVariantDiv = document.querySelector(
      ".additional-product-data-selected .additional-product-variant-selected"
    );
    //

    takePriceAdditional =
      parseFloat(additionalProductVariantDiv.dataset.variantPrice) / 100;
    var takePriceMain =
      parseFloat(mainProductVariantDiv.dataset.variantPrice) / 100;
    var makeBundleFinalPrice = (takePriceAdditional + takePriceMain).toFixed(2);
    var makeBundleFinalString = makeBundleFinalPrice.toString();
    var makeBundleFinalPriceWithSymbol = "€ " + makeBundleFinalString + " EUR";
    document.querySelector(".product-info__price sale-price").innerHTML =
      makeBundleFinalPriceWithSymbol.replace(".", ",");

    //

    takePriceCompareAdditional =
      parseFloat(additionalProductVariantDiv.dataset.comparePrice) / 100;
    var takePriceMainCompare =
      parseFloat(mainProductVariantDiv.dataset.comparePrice) / 100;
    var makeBundleFinalPriceCompare = (
      takePriceCompareAdditional + takePriceMainCompare
    ).toFixed(2);
    var makeBundleFinalStringCompare = makeBundleFinalPriceCompare.toString();
    var makeBundleFinalPriceWithSymbolCompare =
      "€ " + makeBundleFinalStringCompare + " EUR";
    document.querySelector(".product-info__price compare-at-price").innerHTML =
      makeBundleFinalPriceWithSymbolCompare.replace(".", ",");

    // savings changes on price change
    if (additionalProductVariantDiv) {
      // var always_saving =
      //   document.querySelector('.product-info__price compare-at-price').style.display='none';
      //   document.querySelector('.product-info__badge-list').style.display='none';
    }

    document.querySelector(".product-info__price compare-at-price").innerHTML =
      document.querySelector(".always-compare-price-with-symbol").value;
    console.log(
      "always compare pric with symbol:",
      document.querySelector(".always-compare-price-with-symbol").value
    );

    var savings =
      (makeBundleFinalPrice /
        parseFloat(document.querySelector(".always-compare-price").value)) *
      100;
    document.querySelector(
      ".product-info__price_bundle on-sale-badge"
    ).innerHTML =
      "<span class='saving-lang-text'></span> " +
      (100 - savings.toFixed(0)) +
      "%";
  }
}, 500);

// *****************************************************************************
//  Klaviyo integration + Add-to-Cart enable/disable logic
// *****************************************************************************
setInterval(() => {
  const buyBtn = document.querySelector("#custom-buy-button");
  const isLastChance = window.productTags.includes("letztechance");

  // MAIN OPTIONS
  const mainOpt1 = document.querySelector(
    ".fi-custom-option-selector-main-product .option-set-1 .destination"
  )?.dataset.optionValue;
  const opt2C = document.querySelector(
    ".fi-custom-option-selector-main-product .option-set-2"
  );
  const needMainOpt2 =
    !opt2C.classList.contains("hidden") &&
    opt2C.querySelectorAll(".item").length > 1;
  const mainOpt2 = needMainOpt2
    ? document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      )?.dataset.optionValue
    : null;

  // ADDITIONAL-PRODUCT ID + FIRST-OPTION VALUE
  const addDest = document.querySelector(
    ".fi-custom-option-selector-additional-product .destination"
  )?.dataset.productId;
  const addOpt1 = document.querySelector(
    ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
  )?.dataset.optionValue;

  // Detect “I already have a harness” choice
  const skipAdditional = addOpt1 === "Ich möchte kein Brustband";

  // --- VALIDATION ---

  // Must pick all required main opts
  if (
    !mainOpt1 ||
    mainOpt1 === "empty" ||
    (needMainOpt2 && (!mainOpt2 || mainOpt2 === "empty"))
  ) {
    buyBtn.disabled = true;
    buyBtn.textContent = "Bitte Kombination auswählen";
    hideNotifyButton();
    return;
  }

  // If not skipping additional, force full additional selection
  if (!skipAdditional) {
    // Must pick an additional product
    if (!addDest || addDest === "empty") {
      if (!addOpt1 || addOpt1 === "empty") {
        if (mainOpt1 || mainOpt1 === "empty") {
          buyBtn.disabled = true;
          buyBtn.textContent = "Ausverkauft";
          showNotifyButton("main");
        } else {
          buyBtn.disabled = true;
          buyBtn.textContent = "Bitte Kombination auswählen";
          hideNotifyButton();
          return;
        }
      }
    }
    // Must pick both its options
    const addOpts = Array.from(
      document.querySelectorAll(
        ".fi-custom-option-selector-additional-product-selected .destination"
      )
    ).map((el) => el.dataset.optionValue);
    if (addOpts.includes("empty")) {
      buyBtn.disabled = true;
      buyBtn.textContent = "Bitte Kombination auswählen";
      hideNotifyButton();
      return;
    }

    if (!addOpt1 || addOpt1 === "empty") {
      if (mainOpt1 || mainOpt1 === "empty") {
        buyBtn.disabled = true;
        buyBtn.textContent = "Ausverkauft";
        showNotifyButton("main");
      }
    }
  }

  // --- STOCK CHECK ---
  const mainSoldOut =
    document.querySelector(".main-product-variant-selected")?.dataset
      .variantAvailability === "Not Available";
  const addSoldOut =
    !skipAdditional &&
    document.querySelector(".additional-product-variant-selected")?.dataset
      .variantAvailability === "Not Available";

  if (mainSoldOut || addSoldOut) {
    buyBtn.disabled = true;
    buyBtn.textContent = "Ausverkauft";
    if (!isLastChance) {
      showNotifyButton(mainSoldOut ? "main" : "additional");
    }
  } else {
    buyBtn.disabled = false;
    buyBtn.textContent = "In den Warenkorb";
    hideNotifyButton();
  }
}, 300);

// for main product color to be selected auto if color is only 1

setInterval(() => {
  var main_product_option1 = document.querySelector(
    ".fi-custom-option-selector-main-product .option-set-1 .destination"
  ).dataset.optionValue;
  var main_product_option2 = document.querySelector(
    ".fi-custom-option-selector-main-product .option-set-2 .destination"
  ).dataset.optionValue;
  var main_product_selected_variant_id = null;

  document
    .querySelectorAll(".main-product-options-data")
    .forEach(function (mainProductOptionsDataItem) {
      mainProductOptionsDataItem.classList.remove(
        "main-product-variant-selected"
      );
      if (
        mainProductOptionsDataItem.dataset.optionFirst ==
          main_product_option1 &&
        mainProductOptionsDataItem.dataset.optionSecond == main_product_option2
      ) {
        main_product_selected_variant_id =
          mainProductOptionsDataItem.dataset.variantId;
      }
    });

  document
    .querySelector(
      `.main-product-options-data[data-variant-id="${main_product_selected_variant_id}"]`
    )
    .classList.add("main-product-variant-selected");
}, 440);

// Options Availability
// if main product has a single color pre selected
setInterval(() => {
  if (
    document
      .querySelector(".fi-custom-option-selector-main-product .option-set-2")
      .classList.contains("hidden")
  ) {
    var mainProductOption2 = null;
    var mainProductOption2Availability = [];

    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      ).dataset.optionValue
    ) {
      mainProductOption2 = document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      ).dataset.optionValue;
    }

    document
      .querySelectorAll(".main-product-data .main-product-options-data")
      .forEach((e) => {
        if (e.dataset.optionSecond == mainProductOption2) {
          mainProductOption2Availability.push(e.dataset.variantAvailability);
        }
      });

    const mainProductOptionsitems = document.querySelectorAll(
      ".fi-custom-option-selector-main-product .dropdown .item"
    );

    mainProductOptionsitems.forEach((item, index) => {
      if (index < mainProductOption2Availability.length) {
        item.classList.add(
          `variant-${mainProductOption2Availability[index].replace(" ", "")}`
        );
      }
    });
  }
}, 100);
// Options Availability
// if main product has more than one color and not pre selected

setInterval(() => {
  document
    .querySelectorAll(
      ".fi-custom-option-selector-main-product .option-set-1 .item"
    )
    .forEach((opt1Item) => {
      opt1Item.onclick = function () {
        if (
          !document
            .querySelector(
              ".fi-custom-option-selector-main-product .option-set-2"
            )
            .classList.contains("hidden")
        ) {
          var mainProductOption1 = null;
          var mainProductOption22Availability = [];
          mainProductOption1 = document.querySelector(
            ".fi-custom-option-selector-main-product .option-set-1 .destination"
          ).dataset.optionValue;

          document
            .querySelectorAll(".main-product-data .main-product-options-data")
            .forEach((e) => {
              if (e.dataset.optionFirst == mainProductOption1) {
                mainProductOption22Availability.push(
                  e.dataset.variantAvailability
                );
              }
            });

          const mainProductOptionsitems = document.querySelectorAll(
            ".fi-custom-option-selector-main-product .option-set-2  .item"
          );

          mainProductOptionsitems.forEach((item, index) => {
            item.classList.remove("variant-Available");
            item.classList.remove("variant-NotAvailable");
            if (index < mainProductOption22Availability.length) {
              item.classList.add(
                `variant-${mainProductOption22Availability[index].replace(
                  " ",
                  ""
                )}`
              );
            }
          });
        }
      };
    });
}, 10);
// Options Availability
// For Additional product

//

setInterval(() => {
  document
    .querySelectorAll(
      ".fi-custom-option-selector-additional-product-selected .option-set-1 .item"
    )
    .forEach((opt1Item) => {
      opt1Item.onclick = function () {
        var AdditionalProductOption1 = null;
        var AdditionalProductOption2Availability = [];
        AdditionalProductOption1 = document.querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
        ).dataset.optionValue;

        document
          .querySelectorAll(
            ".additional-product-data-selected .additional-product-options-data"
          )
          .forEach((e_Add) => {
            if (e_Add.dataset.optionFirst == AdditionalProductOption1) {
              AdditionalProductOption2Availability.push(
                e_Add.dataset.variantAvailability
              );
            }
          });

        const mainProductOptionsitems = document.querySelectorAll(
          ".fi-custom-option-selector-additional-product-selected .option-set-2  .item"
        );

        mainProductOptionsitems.forEach((item, index) => {
          item.classList.remove("variant-Available");
          item.classList.remove("variant-NotAvailable");
          if (index < AdditionalProductOption2Availability.length) {
            item.classList.add(
              `variant-${AdditionalProductOption2Availability[index].replace(
                " ",
                ""
              )}`
            );
          }
        });
      };
    });
}, 1);

// main product stock show
// setInterval(() => {
//   var inventoryQuantity = document.querySelector(
//     ".main-product-variant-selected"
//   ).dataset.inventoryQuantity;
//   if (inventoryQuantity && inventoryQuantity != "null") {
//     var qtyWidth = inventoryQuantity * 3;
//     document.querySelector(
//       ".main-product-stock-inventory .qty-info"
//     ).innerHTML = ${inventoryQuantity} auf Lager;
//     document.querySelector(
//       ".main-product-stock-inventory .qty-width"
//     ).dataset.qtyWidth = qtyWidth + "%";
//     document.documentElement.style.setProperty("--qtyWidth", qtyWidth + "%");
//     document.documentElement.style.setProperty("--qtyWidthColor", "#ccc");
//   }
// }, 500);

// slider image change
setInterval(() => {
  // for Additional product variant 2nd image change in slider
  document
    .querySelectorAll(
      ".fi-custom-option-selector-additional-product-selected .item"
    )
    .forEach((element) => {
      element.onclick = function () {
        document.querySelector(".fi-product-gallery__thumbnail-custom").click();
      };
    });
  var additionalVariantImageSecond = document.querySelector(
    ".additional-product-data-selected .additional-product-variant-selected"
  ).dataset.imageSecond;
  document.querySelector(".fi-product-gallery__thumbnail-custom img").src =
    additionalVariantImageSecond;
  document.querySelector(".fi-product-gallery__media-custom img").src =
    additionalVariantImageSecond;
}, 200);

// Helper function to update the images
function updateVariantImages(imageSource) {
  setTimeout(() => {
    const thumbnailImg = document.querySelector(
      ".fi-product-gallery__thumbnail-custom img"
    );
    const mediaImg = document.querySelector(
      ".fi-product-gallery__media-custom img"
    );

    if (thumbnailImg && mediaImg) {
      thumbnailImg.src = imageSource;
      mediaImg.src = imageSource;
      document.querySelector(".fi-product-gallery__thumbnail-custom").click(); // Trigger the click after image update
    }
  }, 100); // Small delay to ensure DOM updates
}

// Event listener for main product selection
document
  .querySelectorAll(".fi-custom-option-selector .item")
  .forEach((mainEl) => {
    mainEl.addEventListener("click", () => {
      setTimeout(() => {
        const mainVariantImageSecond = document.querySelector(
          ".main-product-data .main-product-variant-selected"
        )?.dataset.imageSecond;
        if (
          !document
            .querySelector(".additional-product-data")
            .classList.contains("additional-product-data-selected")
        ) {
          if (mainVariantImageSecond) {
            updateVariantImages(mainVariantImageSecond);
          }
        }
      }, 100); // Delay to ensure the variant selection updates
    });
  });

// Event listener for additional product selection
// document
//   .querySelectorAll(
//     ".fi-custom-option-selector-additional-product-selected .item"
//   )
//   .forEach((element) => {
//     element.addEventListener("click", () => {
//       setTimeout(() => {
//         const additionalVariantImageSecond = document.querySelector(
//           ".additional-product-data-selected .additional-product-variant-selected"
//         )?.dataset.imageSecond;

//         if (additionalVariantImageSecond) {
//           updateVariantImages(additionalVariantImageSecond);
//         }
//       }, 100); // Delay to ensure the variant selection updates
//     });
//   });

//

if (window.innerWidth <= 575) {
  document.addEventListener("scroll", function () {
    const priceDiv = document.querySelector("[data-block-id='price']");
    if (window.scrollY >= 120 && window.scrollY < 1000) {
      priceDiv.style.top =
        document.querySelector("product-gallery").offsetHeight + "px";
      priceDiv.classList.add("make-sticky");
    } else {
      priceDiv.classList.remove("make-sticky");
    }
  });

  window.onscroll = function () {
    stickyFunction();
  };

  var stickyElement = document.querySelector("product-gallery");
  var stickyPosition = stickyElement.offsetTop + 1000;

  function stickyFunction() {
    if (window.pageYOffset >= stickyPosition) {
      stickyElement.classList.remove("sticky");
    } else {
      stickyElement.classList.add("sticky");
    }
  }
}

//

setInterval(() => {
  var mainProductVariantDiv = document.querySelector(
    ".main-product-options-data.main-product-variant-selected"
  );
  var additionalProductVariantDiv = document.querySelector(
    ".additional-product-data-selected .additional-product-variant-selected"
  );
  //
  var takePriceAdditional = 0;
  var takeComparePriceAdditional = 0;
  takePriceAdditional =
    parseFloat(additionalProductVariantDiv.dataset.variantPrice) / 100;
  var takePriceMain =
    parseFloat(mainProductVariantDiv.dataset.variantPrice) / 100;
  var makeBundleFinalPrice = (takePriceAdditional + takePriceMain).toFixed(2);
  var makeBundleFinalString = makeBundleFinalPrice.toString();
  var makeBundleFinalPriceWithSymbol = "€ " + makeBundleFinalString + " EUR";
  document.querySelector(".product-info__price sale-price").innerHTML =
    makeBundleFinalPriceWithSymbol.replace(".", ",");
}, 500);

// UPDATED: Remove disabled logic - all dropdowns are now clickable
// document
//   .querySelectorAll(
//     ".wrapper-dropdown:not(.fi-custom-option-selector-main-product .option-set-1)"
//   )
//   .forEach((element) => {
//     element.classList.add("make-disbaled");
//   });

setInterval(() => {
  if (
    !document
      .querySelector(".fi-custom-option-selector-main-product .option-set-2")
      .classList.contains("hidden")
  ) {
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(".fi-custom-option-selector-main-product .option-set-2")
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-2 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product #dropdownAddProduct"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product #dropdownAddProduct .destination"
      ).dataset.productId != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-1"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-2"
        )
        .classList.remove("make-disbaled");
    }
  }
  if (
    document
      .querySelector(".fi-custom-option-selector-main-product .option-set-2")
      .classList.contains("hidden")
  ) {
    if (
      document.querySelector(
        ".fi-custom-option-selector-main-product .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product #dropdownAddProduct"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product #dropdownAddProduct .destination"
      ).dataset.productId != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-1"
        )
        .classList.remove("make-disbaled");
    }
    if (
      document.querySelector(
        ".fi-custom-option-selector-additional-product-selected .option-set-1 .destination"
      ).dataset.optionValue != "empty"
    ) {
      document
        .querySelector(
          ".fi-custom-option-selector-additional-product-selected .option-set-2"
        )
        .classList.remove("make-disbaled");
    }
  }
}, 800);

// Notification Button Funktionen
function showNotifyButton(productType) {
  let notifyButton = document.querySelector("#notify-when-available");
  const isLastChance = window.productTags.includes("letztechance");

  if (!isLastChance) {
    if (!notifyButton) {
      createNotifyButton();
      notifyButton = document.querySelector("#notify-when-available");
    }

    notifyButton.style.display = "block";
    notifyButton.dataset.productType = productType;
  }
}

function hideNotifyButton() {
  const notifyButton = document.querySelector("#notify-when-available");
  if (notifyButton) {
    notifyButton.style.display = "none";
  }
}

function createNotifyButton() {
  const buyButton = document.querySelector("#custom-buy-button");
  const notifyButton = document.createElement("div");
  notifyButton.id = "notify-when-available";
  notifyButton.innerHTML = `
    <div id="notify-message" style="display: none;
      padding: 0.75rem;
      border: 1px solid #e57373;
      background: #ffebee;
      color: #c62828;
      border-radius: 4px;
      margin-bottom: 1rem;
      font-size: 0.9rem;"></div>
  
  <button type="button" class="button--xl button button--primary" id="notify-btn" style="width: 100%; margin-bottom: 10px;">
    Benachrichtige mich, wenn verfügbar
  </button>

  <div class="notify-form" style="display: none;">
    <input
      type="email"
      placeholder="Ihre E-Mail-Adresse"
      id="notify-email"
      required
      style="width: 100%; padding: 10px; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 4px;"
    />
      <button
        type="button"
        class="button button--secondary button--xl"
        id="subscribe-notify"
        style="flex: 1;"
      >
        Benachrichtige mich
      </button>
      <button
        type="button"
        class="button button--tertiary button--xl"
        id="cancel-notify"
        style="flex: 1;"
      >
        Abbrechen
      </button>
    </div>
  </div>
`;

  buyButton.parentNode.insertBefore(notifyButton, buyButton);

  // Event Listeners
  document
    .querySelector("#notify-btn")
    .addEventListener("click", showEmailForm);
  document
    .querySelector("#subscribe-notify")
    .addEventListener("click", subscribeToKlaviyo);
  document
    .querySelector("#cancel-notify")
    .addEventListener("click", hideEmailForm);
}

function showEmailForm() {
  document.querySelector("#notify-btn").style.display = "none";
  document.querySelector(".notify-form").style.display = "block";
}

function hideEmailForm() {
  document.querySelector("#notify-btn").style.display = "block";
  document.querySelector(".notify-form").style.display = "none";
  document.querySelector("#notify-email").value = "";
}
// helper to turn a raw variant ID into Klaviyo’s “composite” format
function buildCompositeId(rawVariantId) {
  // adjust "$shopify" / "$default" if on a different integration
  return `$shopify:::$default:::${rawVariantId}`;
}

// low-level call for one variant
async function subscribeVariant(email, compositeVariantId) {
  const payload = {
    data: {
      type: "back-in-stock-subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: { email },
          },
        },
        channels: ["EMAIL"],
      },
      relationships: {
        variant: {
          data: {
            type: "catalog-variant",
            id: compositeVariantId,
          },
        },
      },
    },
  };

  const res = await fetch(
    `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=W4wgPX`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    }
  );

  if (res.status !== 202) {
    throw new Error(
      `Subscription failed for ${compositeVariantId} (status ${res.status})`
    );
  }
}

// top-level subscribe handler
async function subscribeToKlaviyo() {
  const email = document.querySelector("#notify-email").value;
  if (!email) {
    showInfo("Bitte geben Sie Ihre E-Mail-Adresse ein", true);
    return;
  }

  // find whichever variants are currently marked “Not Available”
  const toSubscribe = [];
  const mainEl = document.querySelector(".main-product-variant-selected");
  if (mainEl?.dataset.variantAvailability === "Not Available") {
    toSubscribe.push({
      type: "Mantel",
      id: buildCompositeId(mainEl.dataset.variantId),
    });
  }

  const addEl = document.querySelector(
    ".additional-product-data-selected .additional-product-variant-selected"
  );
  if (addEl?.dataset.variantAvailability === "Not Available") {
    toSubscribe.push({
      type: "Brustband",
      id: buildCompositeId(addEl.dataset.variantId),
    });
  }

  if (toSubscribe.length === 0) {
    showInfo("Beide Produkte sind verfügbar – kein Benachrichtung nötig.");
    return;
  }

  try {
    // fire off one subscription per variant in parallel
    await Promise.all(
      toSubscribe.map((item) => subscribeVariant(email, item.id))
    );
    hideEmailForm();

    // build a nice success message
    let msg;
    if (toSubscribe.length === 2) {
      msg =
        "Vielen Dank! Wir benachrichtigen dich, sobald beide Produkte wieder verfügbar sind.";
    } else {
      msg = `Vielen Dank! Wir benachrichtigen dich, sobald dein ${toSubscribe[0].type} wieder verfügbar ist.`;
    }
    showInfo(msg);
  } catch (err) {
    console.error(err);
    showInfo(
      "Entschuldigung, es gab einen Fehler bei der Anmeldung. Bitte versuche es später erneut.",
      true
    );
  }
}

// Utility to show a temporary info message under the notify button
function showInfo(message, isError = false) {
  const msgCtn = document.querySelector("#notify-message");
  if (!msgCtn) return;

  // Populate & style
  msgCtn.textContent = message;
  msgCtn.style.display = "block";

  // If you ever want a non-error info style:
  if (!isError) {
    msgCtn.style.background = "#e3f2fd"; // light blue bg
    msgCtn.style.borderColor = "#64b5f6"; // blue border
    msgCtn.style.color = "#1565c0"; // dark blue text
  } else {
    msgCtn.style.background = "#ffebee";
    msgCtn.style.borderColor = "#e57373";
    msgCtn.style.color = "#c62828";
  }

  // Auto-clear after 3s
  clearTimeout(msgCtn._hideTimeout);
  msgCtn._hideTimeout = setTimeout(() => {
    msgCtn.textContent = "";
    msgCtn.style.display = "none";
  }, 3000);
}
